import { Box, styled, Typography } from '@mui/material';

export const SummaryContainer = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'hasTopMargin' && prop !== 'bottomMargin',
})(({ theme, hasTopMargin, bottomMargin }) => ({
  marginTop: hasTopMargin ? '32px' : 0,
  marginBottom: bottomMargin && `${bottomMargin}px`,
  [theme.breakpoints.up('md')]: {
    marginTop: hasTopMargin ? '56px' : 0,
    marginInline: 0,
  },
}));

export const HeaderStyled = styled(Typography)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.colors.highlight}`,
  fontSize: '20px',
  fontWeight: 700,
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.onPrimaryBackground,
  paddingBottom: '8px',
  marginBottom: '8px',
}));
